//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TransientObject.js";
let d=[[[0,"Anchor",1,"Point",1],[0,"PartName",1,1],[0,"SymbolName",1,1]],[[[],"Dispose",{},0,1],[["geom"],"SetGeometry",{},1,1],[[],"GetPath",{R_:{path:''}},0,1],[["path"],"SetPath",{},1,1]],[]];
SPLM.Annotations.MasterCustomSymbolData = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.MasterCustomSymbolData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;